<template>
	<div class="index">
		    <!-- 学习心得详情对话框 -->
			<el-dialog
			:modal="true"
			:modal-append-to-body="false"
			:fullscreen="false"
			:visible.sync="centerDialogVisible"
			width="650px"
			center>
			<div class="dialog_title" slot="title">
				<div class="title_icon"><img src="../../assets/xiangning/ztpx/danghui_yellow.png" alt=""></div>
				<div class="title_text" v-if="$store.state.user.userinfo2.flag==4">新增学习心得记录</div>
				<div class="title_text" v-else>新增汇报记录</div>
			</div>
			<div class="addWrap">
				 <!-- <div class="addWrap_top">
					汇报人: <span>人民一线党支部</span>
				 </div>	 -->
				 <div class="addWrap_top" style="margin-top: 20px;">
					正文内容：
				 </div>	
				 <div class="addWrap_content">
					<quill-editor :options="$VueQuillEditor" ref="myTextEditor" v-model="addRecordDate.content" style="height:325px !important;width: 590px;"></quill-editor>
				 </div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="submitRecord"  class="footer_button" type="primary" >提交</el-button>
			</span>
	        </el-dialog>
			<div class="djxxDetail_wrap">
			      <!-- 上方新闻信息 -->
				  <div class="top_content">
                    <div class="left_pic">
                        <img :src="pxrwDetail.sz_img" alt="">
                    </div>
                    <div class="right_content">
                         <div class="right_content_top">
                            <div class="right_content_top_left">
                                {{ pxrwDetail.title }}
                            </div>
                            <!-- <div class="right_content_top_right">
                                聚焦二十大
                            </div> -->
                         </div>
						 <div class="ztpx_content_center">
							<!-- <div 
							v-if="pxrwDetail.examination==1&getdata.flag==4"
							class="ztpx_content_center_item">
                              在线考试
							</div> -->
							<div 
							v-if="pxrwDetail.experience==1&getdata.flag==4"
							class="ztpx_content_center_item" @click="centerDialogVisible=true">
                              学习心得
							</div>
							<div 
							@click="centerDialogVisible=true"
							v-if="pxrwDetail.record==1&getdata.flag!=4"
							class="ztpx_content_center_item">
                              汇报记录
							</div>
						 </div>
						 <div class="ztpx_content_pxinfo">
                             <div class="ztpx_content_pxinfo_left">
								 <div class="ztpx_content_pxinfo_left_time_icon">
                                       <img src="../../assets/xiangning/ztpx/ztpx_time.png" alt="">
								 </div>
								 <div class="ztpx_content_pxinfo_left_time_right_text">
									{{pxrwDetail.s_time}}至{{ pxrwDetail.e_time }}
								 </div>
								 
							 </div>
                             <div class="ztpx_content_pxinfo_right">
								<!-- 状态：<span style="color: #1DA3FA;">进行中</span> -->
							 </div>
						 </div>
                          <!-- 下方课程信息 -->
                          <div class="dataList_item_bottom_botom">
                            <div class="dataList_item_bottom_botom_item">
                              <div class="dataList_item_bottom_botom_item_icon">
                                  <img src="../../assets/xiangning/djxx_detail/icon_1.png" alt="">
                              </div>
                              <div class="dataList_item_bottom_botom_item_content">
                                  共{{pxrwDetail.count}}课
                              </div>
                            </div>
                            <div class="dataList_item_bottom_botom_item">
                              <div class="dataList_item_bottom_botom_item_icon">
                                  <img src="../../assets/xiangning/djxx_detail/icon_3.png" alt="">
                              </div>
                              <div class="dataList_item_bottom_botom_item_content">
                                  {{pxrwDetail.hours.substring(0,3)}}课时
                              </div>
                            </div> 
                            <div class="dataList_item_bottom_botom_item" style="margin-right: 10px;">
                              <div class="dataList_item_bottom_botom_item_icon">
                                  <img src="../../assets/xiangning/djxx_detail/icon_2.png" alt="">
                              </div>
                              <div class="dataList_item_bottom_botom_item_content">
                                {{ pxrwDetail.nums }}
                              </div>
                            </div>
							<!-- <div class="dataList_item_bottom_botom_item" style="width: 200px;">
                              <div class="dataList_item_bottom_botom_item_icon">
                                  <img src="../../assets/xiangning/ztpx/people_nums.png" alt="">
                              </div>
                              <div class="dataList_item_bottom_botom_item_content">
                                  学完20人
                              </div>
                            </div> -->
                        </div>
                    </div>
                 </div>
                 <!-- 下方课程列表 -->
                 <div class="bottom_List">
                    <!-- 课程目录标题 -->
                     <div class="bottom_List_title">
						<div class="title_left">
                            <img src="../../assets/xiangning/home/titile_left.png" alt="">
						</div>
                         <div class="bottom_List_title_center">课程目录</div>
						 <div class="right_back" @click="$router.go(-1)">
							<div class="right_back_icon"><img src="../../assets/xiangning/newsCenter/back.png" alt=""></div>
							<div >返回</div>
                        </div>
                     </div>
                     <!-- 课程目录内容 -->
                     <div class="bottom_List_main">
                           <!-- 每一个课程 -->
                          <div class="bottom_List_main_item" @click="geDjxxResouce(item)"  v-for="item in FileList" :key="item.id">
                               <!-- 圆形改变颜色可根据数据改变圆形的颜色-->
                               <div :style="{borderColor:true?'#64C59C':''}" class="bottom_List_main_item_cicrl">
                                <!-- 内侧圆心颜色 -->
                                   <div :style="{backgroundColor:true?'#64C59C':''}"   class="bottom_List_main_item_cicrl_inter"></div>
                               </div>
                              <div class="bottom_List_main_item_lefttitle">{{ item.title }}</div>
                              <!-- 右侧学习时长 -->
                              <div class="bottom_List_main_item_right">
                                <!-- 左侧资源类型图标-->
								<div class="bottom_List_main_item_right_time">
                                    {{ item.durs}}
                                  </div>
                                 <!-- pdf类型 -->
								 <div class="bottom_List_main_item_right_pic" v-if="item.bsid=='8'">
                                       <img src="../../assets/xiangning/djxx_detail/pdf.png" alt="">
                                  </div>
                                   <!-- 图片类型 -->
                                  <div class="bottom_List_main_item_right_pic" v-if="item.bsid=='2'">
                                    <img src="../../assets/xiangning/djxx_detail/pic.png" alt="">
                                   </div>
									<!-- 视频类型 -->
									<div class="bottom_List_main_item_right_pic" 
									v-if="item.bsid=='3'">
										<img src="../../assets/xiangning/djxx/video.png" alt="">
									</div>
										<!-- ppt类型 -->
										<div class="bottom_List_main_item_right_pic" 
									v-if="item.bsid=='1'">
										<img src="../../assets/xiangning/djxx/ppt.png" alt="">
									</div>
									<div class="progress">
										<div class="progress_content">已学：</div>
										<div class="progress_item"><el-progress :percentage="Math.floor(Number(item.time)*100/Number(item.dur))" :color="customColors"></el-progress></div>
									</div>
                                  
                              </div>
                          </div> 
                     </div>
                 </div>
				 <div style="height: 50px;"></div>
			 </div>
	     </div>
</template>
<script>
    import { Message } from 'element-ui'
	import Swiper from 'swiper';
	import { ztpx } from '@/axios';
	import Page from '@/components/page.vue'
	export default{
		data(){
			return{
				
			// 总数据条数
			total:100,
			// 当前页码
			per_page:1,
			index:0,
			input:'',
			type:'pdf',
			studyCount:[],
			getdata:{
				uid:this.$store.state.user.userinfo2.id,
				flag:this.$store.state.user.userinfo2.flag,
				tid:this.$route.query.tid
			},
			addRecordDate:{
					tid:this.$route.query.tid,
					// uid:this.$store.state.user.userinfo2.id,
					// flag:this.$store.state.user.userinfo2.flag,
					uid:this.$store.state.user.userinfo2.id,
					flag:this.$store.state.user.userinfo2.flag,
					content:""
			},
			FileList:[],
			pxrwDetail:{},
			centerDialogVisible:false,
			// 进度条
			customColors: [
          {color: '#f56c6c', percentage: 20},
          {color: '#e6a23c', percentage: 40},
          {color: '#5cb87a', percentage: 60},
          {color: '#1989fa', percentage: 80},
          {color: '#6f7ad3', percentage: 100}
        ]
			}
			
		},
		components:{ Page },
		methods:{
			format(percentage) {
				return percentage === 100 ? '满' : `${percentage}%`;
			},
			// 汇报记录提交
			submitRecord(){
				
				let that=this
				// 向服务器提交汇报记录
				ztpx.addExperience(that.addRecordDate).then((res)=>{
					if (res.code==200) {
						Message({
								type:"success",
								message:"提交成功"
							})
							this.centerDialogVisible=false
					}else{

					}
				})
				
			},
			// 获取培训任务详情
			getTrainTaskDetail(){
                 let that=this
				 ztpx.trainTaskDetail(that.getdata).then(res=>{
					if (res.code==200) {
					
						that.pxrwDetail=res.data[0]
						that.FileList=res.data[0].resouce
						that.FileList.forEach((item,index,arr) => {
						arr[index].durs=that.$changeDurs(item.dur)
						});
					}
				 })
			},
			// ztpx资源播放
			geDjxxResouce(data){
				let that=this
				this.$router.push({
					path:'/djxxResouce',
					query:{
						id:data.rid,
						flag:data.flag,
						train_id:that.$route.query.tid
					}
				})
			}
		  },
		mounted(){
	       this.getTrainTaskDetail()
		},
		created() {
			this.$emit("highLight",3,"","","");
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	  
		
	.index{
		.addWrap{
              .addWrap_top{
				width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			  }
			  .addWrap_content{
				margin-top: 20px;
				width: 100%;
				font-family: PingFangSC-Regular;
				font-size: 14px;
				font-weight: normal;
				line-height: 28px;
				text-align: justify; /* 浏览器可能不支持 */
				letter-spacing: 0em;
				color: #000000;
				height: 400px;
				overflow: auto;
				text-indent: 24px;
				img{
					width: 400px;
					height: 240px;
				}
			  }
			 
			  .dialog_pic{
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				height: 150px;
				overflow-y: auto;
                 .dialog_pic_item{
					width: 135px;
					height: 135px;
					margin-right: 16px;
					margin-bottom: 10px;
					img{
						width: 100%;
						height: 100%;
					}
				 }
				 .dialog_pic_item:nth-child(4n){
					margin-right: 0;
				 }
			  }
			}
		// 学习心得对话框
		.dialog_title{
		    box-sizing: border-box;
			padding-bottom: 20px;
			display: flex;
			justify-content: center;
			border-bottom: 1px solid #DCDFE6;
			.title_icon{
				width: 24px;
				height: 24px;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.title_text{
				font-family: PingFangSC-Medium;
				font-size: 22px;
				font-weight: 800;
				text-align: center;
				letter-spacing: 0em;
				color: #EA0000;
				margin-left: 12px;
			}
			}
		.dialog-footer{
			.footer_button{
				margin-right: 70px;
			}
		}
		
		.dialog_pic{
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				height: 150px;
				overflow-y: auto;
                 .dialog_pic_item{
					width: 135px;
					height: 135px;
					margin-right: 16px;
					margin-bottom: 10px;
					img{
						width: 100%;
						height: 100%;
					}
				 }
				 .dialog_pic_item:nth-child(4n){
					margin-right: 0;
				 }
			 }
		width: 100%;
		.newsCenterBanenr{
			position: relative;
			width: 100%;
			img{
				width: 100%;
				height: auto;
			}
		
		}
		div{
			box-sizing: border-box;
		}
		
		.djxxDetail_wrap{
			width: $indexWidth;
			margin: auto;
			min-width: 1200px;
			position: relative;
			margin-top: 20px;
		    //上方课程信息
			.top_content{
				height: 242px;
				width: 100%;
				margin-bottom: 20px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				.left_pic{
					width: 384px;
					height: 242px;
					border-radius: 4px;
					overflow: hidden;
					img{
						width: 100%;
						height: 100%;
					}

				}
				.right_content{
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					height: 182px;
					width: 792px;
					.right_content_top{
					height: 32px;
					width: 100%;
					/* background-color: pink; */
					display: flex;
					justify-content: space-between;
						.right_content_top_left{
							width: 512px;
							height: 100%;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							font-family: PingFangSC-Medium;
							font-size: 18px;
							font-weight: 800;
							letter-spacing: 0px;
							color: #000000;

						}
						
					}
				    .ztpx_content_center{
						width: 100%;
						display: flex;
						justify-content: start;
						.ztpx_content_center_item{
							cursor: pointer;
							height: 32px;
							padding:0 16px;
							line-height: 32px;
							background-color: #E10606;
							border-radius: 258px;
							font-family: PingFang SC;
							font-size: 14px;
							font-weight: normal;
							align-items: center;
							letter-spacing: 0px;
							color: #FFFFFF;
							margin-right: 20px;
						}
					}
					.ztpx_content_pxinfo{
						width: 100%;
						height: 20px;
						display: flex;
						.ztpx_content_pxinfo_left{
							height: 100%;
							display: flex;
							.ztpx_content_pxinfo_left_time_icon{
								height: 20px;
								width: 20px;
								img{
									width: 100%;
									height: 100%;
								}
							}
						}
						.ztpx_content_pxinfo_left_time_right_text{
							margin-left: 10px;
                         height: 20px;
						 line-height: 20px;
						 font-family: PingFang SC;
						font-size: 14px;
						font-weight: normal;
						letter-spacing: 0em;
						color: #7C7C7C;
						}
						.ztpx_content_pxinfo_right{
							margin-left: 57px;
							height: 100%;
							font-family: PingFang SC;
							font-size: 14px;
							font-weight: normal;
							letter-spacing: 0em;
						}
					}
					
					.dataList_item_bottom_botom{
						height: 16px;
						width: 100%;
						display: flex;
						.dataList_item_bottom_botom_item{
							overflow: hidden;
							height: 100%;
							width: 74px;
							display: flex;
							justify-content: center;
							.dataList_item_bottom_botom_item_icon{
								height: 12px;
								width: 12px;
								margin-right: 2px;
								position: relative;
								img{
									position: absolute;
									top: 2.5px;
								}
							}
							.dataList_item_bottom_botom_item_content{
								font-family: PingFangSC-Regular;
								font-size: 12px;
								font-weight: normal;
								letter-spacing: 0em;
								color: #999999;
							}
						}
						.dataList_item_bottom_botom_item:nth-child(2){
							border-left: 1px solid #ECEEF4;
				 
						}
						.dataList_item_bottom_botom_item:nth-child(1){
						display: flex;
						justify-content: start;
						}
						.dataList_item_bottom_botom_item:nth-child(3){
							display: flex;
							justify-content: center;
							border-left: 1px solid #ECEEF4;
							.dataList_item_bottom_botom_item_icon{
								height: 10px;
								width: 15px;
							}
						}
						.dataList_item_bottom_botom_item:nth-child(4){
						    
							border-left: 1px solid #ECEEF4;;
							display: flex;
							justify-content: start;
							.dataList_item_bottom_botom_item_icon{
								margin-left: 10px;
								height:15px;
								width: 15px;
								margin-right: 5px;
								img{
									width: 100%;
									height: 100%;
								}
							}
						}
					}
				}
			}
			/* 下方课程列表 */
			.bottom_List_title{
				height: 32px;
				width: 100%;
				margin:20px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding-left:32px;
				background: #FFF6F1;
				box-sizing: border-box;
				position: relative;
				.title_left{
					position: absolute;
					top: -5px;
					left: 0;
					height: 42px;
					width: 42px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.bottom_List_title_center{
					width: 100%;
					height: 22px;
					box-sizing: border-box;
				
					padding-left: 8px;
					font-family: PingFangSC-Medium;
					font-size: 16px;
					font-weight: 800;
					letter-spacing: 0.1em;
					color: #D31813;
                
				}
				.right_back{
				display: flex;
				font-family: PingFangSC-Regular;
				font-size: 12px;
				font-weight: normal;
				letter-spacing: 0em;
				color: #666666;
				margin-right: 10px;
				width: 50px;
			}
			.right_back:hover{
				font-weight: 800;
				color: #EE632B;
			}
			.right_back_icon{
				height: 10px;
				width: 12px;
				margin-right: 5px;
			}
			.right_back_icon img{
				height: 100%;
				width: 100%;
			}
			}
			.bottom_List_main{
				width: 100%;
				/* background-color: pink; */
				margin-top: 20px;
				padding-left: 24px;
				box-sizing: border-box;
				.bottom_List_main_item{
					position: relative;
					width: 100%;
					height: 54px;
					border-left:2px solid #D8D8D8;
					padding-left: 26px;
					display: flex;
					justify-content: space-between;
					.bottom_List_main_item_cicrl{
						position: absolute;
						top: 5px;
						left: -8px;
						width: 14px;
						height: 14px;
						box-sizing: border-box;
						border-radius: 50%;
						border: 2px solid #D8D8D8;
						background-color: #FFFFFF;
						display: flex;
						justify-content: center;
						align-items: center;
						.bottom_List_main_item_cicrl_inter{
							height: 6px;
							width: 6px;
							box-sizing: border-box;
							border-radius: 50%;
							background-color: #D8D8D8; 
							
						}

					}
					.bottom_List_main_item_lefttitle{
						width: 600px;
						height: 20px;
						font-family: PingFangSC-Regular;
						font-size: 14px;
						font-weight: normal;
						letter-spacing: 0em;
						color: #000000;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					.bottom_List_main_item_lefttitle:hover{
						color: #C9010A;
						font-weight: 800;
					}
					.bottom_List_main_item_right{
						height: 24px;
				
						box-sizing: border-box;
						display: flex;
						justify-content: start;
						.bottom_List_main_item_right_pic{
							height: 100%;
							/* width: 100%; */
							width: 24px;
							margin-right:11px;
                            img{
								width: 100%;
								height: 100%;
							}
						}
						.bottom_List_main_item_right_time{
							font-family: PingFangSC-Regular;
							font-size: 12px;
							font-weight: normal;
							text-align: center;
							letter-spacing: 0em;
							color: #787878;
							white-space: nowrap;
							line-height: 22px;
							width: 80px;
						}
						.progress{
							
							display: flex;
							align-items: center;
							.progress_content{
								width: 40px;
								font-family: PingFangSC-Regular;
								font-size: 12px;
								font-weight: normal;
								letter-spacing: 0em;

								color: #787878;
							}
							.progress_item{
								width: 200px;
							}
						}
					}
				}
				.bottom_List_main_item:nth-child(1) .bottom_List_main_item_cicrl{
					position: absolute;
					top: 0px;
					left: -8px;
					width: 14px;
					height: 14px;
					box-sizing: border-box;
					border-radius: 50%;
					border: 2px solid #D8D8D8;
				}

			}
			
		}
	}
		
			
</style>
